import { render, staticRenderFns } from "./PresetImportDialog.vue?vue&type=template&id=c284691a&"
import script from "./PresetImportDialog.vue?vue&type=script&lang=ts&"
export * from "./PresetImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports